import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/components/IndustriesCards/IndustriesCards.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/components/IndustriesHero/IndustriesHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/components/IndustriesProcess/IndustriesProcess.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/components/IndustriesSolutions/IndustriesSolutions.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryChoose/IndustryChoose.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryCTA/IndustryCTA.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryDocuments/IndustryDocuments.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryHero/IndustryHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryLanguages/IndustryLanguages.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryLogos/IndustryLogos.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryOffer/IndustryOffer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryPricingPlans/IndustryPricingPlans.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/industries/Industry/components/IndustryProcess/IndustryProcess.tsx");
